<template>
  <div>
    <div v-if="loadingOverlay === true">
       <div class="lds-dual-ring"></div>
    </div>
    <div>
      <H5>Search By:</H5>
      <div>
        <p-button
          type="info"
          size="sm"
          round
          v-for="button in  searchTypeButtons"
          :key="button.type"
          @click="toggleSearch(button)"
          :class="{ searchSelected: button.selected }"
        >{{button.text}}</p-button>
      </div>

      <form ref="searchForm" @submit.prevent="searchSubmit">
        <div v-if="searchType =='hashtag' ">
          <div class="row">
            <div class="col-md-8">
              <div style="margin-top:10px;">
                <p style="font-weight:bold;">Enter Keywords:</p>

                <tags-input
                  element-id="tags"
                  wrapper-class="hashtag-search-input"
                  v-if="searchType =='hashtag'"
                  v-model="searchHashtagList"
                  :existing-tags="hashtagList"
                  @change="loadHashtags"
                  :typeahead="true"
                ></tags-input>
              </div>
            </div>

            <div class="col-md-4">
              <div style="margin-top:10px;">
                <p style="font-weight:bold;"># of hashtags:</p>

                <input
                  class="search-field"
                  style="width: 100px !important;"
                  :placeholder="topHashtagCount"
                  v-if="searchType =='hashtag'"
                  v-model="topHashtagCount"
                />
              </div>
            </div>
          </div>

          <p-button @click="hashtagSearch">Search</p-button>
        </div>
        <div v-if="searchType =='hashtag_smart' ">
          <vue-autosuggest
            :v-model="setLocationFieldDisplay"
            :suggestions="locationList"
            @input="loadLocations"
            @selected="locationSearch"
            :input-props="locationProps"
          ></vue-autosuggest>
        </div>

        <!--<div>
            <v-btn @click.prevent="searchSubmit">SEARCH</v-btn>
        </div>-->
      </form>
    </div>
    <div v-if="loadSearch == true">
       <div class="lds-dual-ring"></div> 
    </div>
    <div v-if="searchResults != null">
      <div v-if="searchType =='hashtag'">
        <div class="card" v-if="topHashtagList !=null">
          <div class="card-header">
            <h5 class="card-title">Top {{topHashtagList.length}} hashtags:</h5>
          </div>
          <div style="padding: 15px;">
            <span
              class="hashtag-item"
              v-for="hashtag in topHashtagList"
              :key="hashtag.hashtag"
            >#{{hashtag.hashtag}}&nbsp;</span>
          </div>
        </div>
        <div class="card" style="margin-top:25px;">
          <div class="card-header">
            <h5 class="card-title">{{searchResults.length}} hashtags found:</h5>
          </div>

          <div class="card-body row">
            <div class="col-sm-12">
              <el-table
                :data="searchResults"
                header-row-class-name="text-primary"
                class="table-striped"
              >
                <el-table-column label="Hashtag">
                  <template slot-scope="props">
                    <div class="table-cell">{{props.row.hashtag}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="Post Count">
                  <template slot-scope="props">
                    <div class="table-cell">{{props.row.countString}}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else></div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import {
  influencerCandidateSearchRelatedApi,
  influencerCandidateSearchLocationApi,
  influencerCandidateSearchLocationLoadApi,
  influencerCandidateSearchLRelatedLoadApi,
  influencerCandidateSearchHashtagApi,
  influencerCandidateSearchLHashtagLoadApi,
  influencerCandidateSearchKeywordApi,
  influencerCandidateSearchLKeywordLoadApi,
  instagramHashtagSearchApi
} from "@/config/appSettings";
import PPagination from "src/components/UIComponents/Pagination.vue";
import { VueAutosuggest } from "vue-autosuggest";
import VoerroTagsInput from "@voerro/vue-tagsinput";
import _ from "underscore";
export default {
  data: () => ({
    loadingOverlay: false,
    loadingOverlayText: null,
    campaigns: null,
    searchResults: null,
    candidateList: null,
    searchType: null,
    searchRelated: null,
    searchHashtag: null,
    searchKeyword: null,
    searchQuery: null,
    searchField: null,
    locationSearchField: null,
    relatedSearchField: null,
    keywordSearchField: null,
    locationSearchName: null,
    hashtagSearchField: null,
    locationList: [],
    locationData: null,
    hashtagList: [],
    searchHashtagList: null,
    progressiveLoad: false,
    currentSearchLocation: null,
    locationProps: null,
    hashtagProps: null,
    inputLocationProps: null,
    topHashtagList: null,
    topHashtagCount: null,
    loadSearch: false,
    searchTypeButtons: [
      { type: "hashtag", text: "hashtag", selected: false }
      /*{ type: "hashtag_smart", text: "smart hashtag", selected: false }*/

      /*{ type: "related_profiles", text: "related profiles", selected: false }*/
    ],
    searchHeaders: [
      {
        text: "",
        align: "left",
        sortable: false,
        value: ""
      },
      { text: "Instagram", value: "profileName" },
      { text: "Bio", value: "bio", sortable: false },
      { text: "Followers", value: "followerCount" },
      { text: "Engagement Rate", value: "engagementRate" },
      { text: "", value: "", sortable: false }
    ]
  }),
  name: "InstagramHashtagSearch",
  components: {
    VueAutosuggest,
    "tags-input": VoerroTagsInput
  },
  methods: {
    async toggleSearch(search) {
      //console.log(search);
      try {
        //this.progressiveLoad = false;
        //this.reloadData = {};
        //console.log("BUTTON CLICKED:", search.type)
        //console.log("SEARCH TYPE:", this.searchType)
        //console.log("QUERY TYPE:", this.$route.query.type)
        this.searchType = search.type;
        this.searchTypeButtons = this.searchTypeButtons.map(x => {
          if (search.type == x.type) {
            return { type: x.type, text: x.text, selected: true };
          }
          return { type: x.type, text: x.text, selected: false };
        });
        //console.log("SEARCH TYPE BUTTONS:", this.searchTypeButtons);

        if (this.searchType !== this.$route.query.type) {
          this.$router.push({
            query: { type: this.searchType }
          });
          this.searchType = this.$route.query.type;
          //console.log("CHANGING SEARCH TYPE:", this.searchType);
        }
        this.searchResults = null;

        //this.$refs.searchForm.reset();
        /*if (search.type === "location") {
        this.reloadData = { location: "" };
      }
      if (search.type === "hashtag") {
        this.reloadData = { searchHashtag: "" };
      }*/
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async searchSubmit() {
      try {
        this.searchResults = [];
        if (this.searchType === null) {
          this.searchType = "hashtag";
          this.searchQuery = this.searchField;
        }

        if (this.searchType === "location") {
          this.searchQuery = this.locationSearchField;
        }
        if (this.searchType === "hashtag_smart") {
          this.searchQuery = this.hashtagSmartSearchField;
          this.searchQuery = this.hashtagSearchField;
          this.searchHashtag = this.hashtagSearchField;
        }
        if (this.searchType === "hashtag") {
          this.searchQuery = this.hashtagSearchField;
          this.searchHashtag = this.hashtagSearchField;
        }

        if (this.searchQuery !== this.$route.query.q) {
          this.$router.push({
            query: { q: this.searchQuery, type: this.searchType }
          });
        }
        if (
          this.$route.query.type !== null &&
          this.$route.query.type.trim() !== "" &&
          typeof this.$route.query.type !== "undefined"
        ) {
          this.searchType = this.$route.query.type;
        }

        this.searchRequest();
      } catch (err) {
        console.log(err);
      }
    },
    async hashtagSearch() {
     
      this.loadSearch = true;
      let hashtagList = this.searchHashtagList.map(x => {
        return x.value;
      });

      if (hashtagList.length < 1) {
        return;
      }
      let hashtagSearchString = hashtagList.join(",");
      console.log(hashtagSearchString);

      let hashtagSearchUrl = `${instagramHashtagSearchApi}/?hashtags=${hashtagSearchString}&usertoken=${this.auth}`;
      console.log("SEARCH URL: ", hashtagSearchUrl);
      let hashtagSearchResponse = await axios.get(hashtagSearchUrl);

      console.log(hashtagSearchResponse.data);
      this.searchResults = hashtagSearchResponse.data.result;

      this.topHashtagList = this.searchResults.slice(0, this.topHashtagCount);
      this.loadSearch = false;

      // ERROR IF NO HASHTAGS SELECTED

      //console.log("ITEM:", input);
      /*if (typeof input !== "undefined" && input !== null) {
        this.hashtagSearchField = input.item;
        this.searchSubmit();
        return;
      }
      if (this.hashtagSearchField !== null) {
        this.searchSubmit();
        return;
      }*/
    },
    async locationSearch(input) {
      //console.log("ITEM:", input);
      let locationId = this.locationData.filter(x => {
        return x.name == input.item;
      });
      //console.log("Location Id:", locationId[0]);
      if (typeof input !== "undefined" && input !== null) {
        this.locationSearchField = locationId[0].placeId;
        this.searchSubmit();
        return;
      }
      if (this.locationSearchField !== null) {
        this.searchSubmit();
        return;
      }
    },
    async searchRequest() {
      try {
        //console.log("SEARCH TERM:", this.$route.query.q);
        if (typeof this.$route.query.q === "undefined") {
          return;
        }
        if (this.$route.query.q === null) {
          return;
        }

        if (this.$route.query.q.trim() === "") {
          return;
        }
        if (this.progressiveLoad === false) {
          this.loadingOverlay = true;
        }

        this.loadingOverlayText = "Loading Results...";
        this.searchType = this.$route.query.type;

        //console.log("NO SEARCH QUERY:", this.searchQuery);
      } catch (err) {
        //console.log(err);
      }
    },

    async loadHashtagResults() {
      try {
        if (this.progressiveLoad === false) {
          this.loadingOverlay = true;
        }

        this.loadingOverlayText = "Loading Results...";
        this.searchType = this.$route.query.type;

        //console.log("HERE IS THE SAVED SEARCH RELOADED: ", this.reloadData);
        let reloadData = {};
        reloadData.usertoken = this.auth;
        reloadData.searchHashtag = this.reloadData.searchHashtag;
        reloadData.profileList = this.reloadData.profileList;

        let influencerCandidateList = await axios.post(
          influencerCandidateSearchLHashtagLoadApi,
          reloadData
        );
        //console.log("RELATED PROFILE DATA: ", influencerCandidateList.data);
        if (influencerCandidateList.data.success === true) {
          this.searchResults = influencerCandidateList.data.result;
          this.searchHashtag = influencerCandidateList.data.searchHashtag;
        }
        //this.loadingOverlay = false;
        if (influencerCandidateList.data.status === "processing") {
          this.progressiveLoad = true;
          setTimeout(() => {
            this.loadHashtagResults();
          }, 6000);
        } else {
          this.progressiveLoad = false;
        }

        this.loadingOverlay = false;

        //console.log("NO SEARCH QUERY:", this.searchQuery);
      } catch (err) {
        //console.log(err);
      }
    },
    async loadKeywordResults() {
      try {
        if (this.progressiveLoad === false) {
          this.loadingOverlay = true;
        }

        this.loadingOverlayText = "Loading Results...";
        this.searchType = this.$route.query.type;

        //console.log("HERE IS THE SAVED SEARCH RELOADED: ", this.reloadData);
        let reloadData = {};
        reloadData.usertoken = this.auth;
        reloadData.searchKeyword = this.reloadData.searchKeyword;
        reloadData.profileList = this.reloadData.profileList;

        let influencerCandidateList = await axios.post(
          influencerCandidateSearchLKeywordLoadApi,
          reloadData
        );
        //console.log("RELATED PROFILE DATA: ", influencerCandidateList.data);
        if (influencerCandidateList.data.success === true) {
          this.searchResults = influencerCandidateList.data.result;
          this.searchKeyword = influencerCandidateList.data.searchKeyword;
        }
        this.loadingOverlay = false;
        if (influencerCandidateList.data.status === "processing") {
          this.progressiveLoad = true;
          setTimeout(() => {
            this.loadKeywordResults();
          }, 6000);
        } else {
          this.progressiveLoad = false;
        }

        this.loadingOverlay = false;

        //console.log("NO SEARCH QUERY:", this.searchQuery);
      } catch (err) {
        //console.log(err);
      }
    },

    async setHashtagValue(val) {
      return val.name;
    },
    async setLocationValue(val) {
      //console.log("VALUE:", val);
      return val.name;
    },
    async setHashtagDisplay(val) {
      return val.item.nameString;
    },
    async setLocationFieldDisplay() {
      if (this.locationSearchField !== null) {
        let locationCheck = this.locationData.filter(x => {
          return x.placeId == this.locationSearchField;
        });
        if (locationCheck.length > 0) {
          return x.name;
        }
      }
    },
    async loadHashtags(val) {
      try {
        //console.log("QUERY:", val);
        if (typeof val !== "undefined") {
          if (val.length > 2) {
            let locationResponse = await axios.get(
              `https://www.instagram.com/web/search/topsearch/?context=hashtag&query=${val}`
            );
            //console.log("CHECKING LOCATIONS:", locationResponse.data);
            let loadedHashtags = locationResponse.data.hashtags.map(x => {
              /*return {
                    name: x.hashtag.name,
                    nameString: `${x.hashtag.name}`
                  };*/
              let emoji = /([#0-9]\u20E3)|[\xA9\xAE\u203C\u2047-\u2049\u2122\u2139\u3030\u303D\u3297\u3299][\uFE00-\uFEFF]?|[\u2190-\u21FF][\uFE00-\uFEFF]?|[\u2300-\u23FF][\uFE00-\uFEFF]?|[\u2460-\u24FF][\uFE00-\uFEFF]?|[\u25A0-\u25FF][\uFE00-\uFEFF]?|[\u2600-\u27BF][\uFE00-\uFEFF]?|[\u2900-\u297F][\uFE00-\uFEFF]?|[\u2B00-\u2BF0][\uFE00-\uFEFF]?|(?:\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDEFF])[\uFE00-\uFEFF]?|[\u20E3]|[\u26A0-\u3000]|\uD83E[\udd00-\uddff]|[\u00A0-\u269F]/g;
              if (x.hashtag.name.match(emoji)) {
                return [];
              }
              if (
                x.hashtag.name.match(
                  /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g
                )
              ) {
                return [];
              }
              return { key: x.hashtag.name, value: x.hashtag.name };
            });

            this.hashtagList = _.flatten(loadedHashtags);
            console.log("HASHTAG LIST:", this.hashtagList);

            return this.hashtagList;
          }
        }
        return this.hashtagList;
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    }
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.searchRequest();
    this.searchType = this.$route.query.type;
    if (this.topHashtagCount == null) {
      this.topHashtagCount = 30;
    }

    console.log("IN SEARCH INSTANCE!");
    try {
      if (
        typeof this.$route.query.type == "undefined" ||
        this.$route.query.type == null
      ) {
        this.searchType = "hashtag";
      } else {
        this.searchType = this.$route.query.type;
      }
    } catch (err) {
      this.searchType = "hashtag";
    }
    try {
      //console.log("SEARCH TYPE:", this.searchType);
      //console.log("SEARCH BUTTONS:", this.searchTypeButtons);

      let searchButton = this.searchTypeButtons.filter(x => {
        return x.type === this.searchType;
      });

      console.log("SEARCH BUTTON:", searchButton[0]);

      this.toggleSearch(searchButton[0]);
    } catch (err) {
      console.log("THERE WAS AN ERROR:", err);
    }

    /*if (
      typeof this.$route.query.q !== "undefined" &&
      this.$route.query.q !== null
    ) {
      this.searchQuery == this.$route.query.q;
      this.searchField == this.$route.query.q;
    }
    this.searchType = this.$route.query.type;
    
    try {
      if (
        typeof this.$route.query.type == "undefined" ||
        this.$route.query.type == null
      ) {
        this.searchType = "keyword";
      } else {
        this.searchType = this.$route.query.type;
      }
    } catch (err) {
      this.searchType = "keyword";
    }
    try {
      console.log("SEARCH TYPE:", this.searchType);
      console.log("SEARCH BUTTONS:", this.searchTypeButtons);

      let searchButton = this.searchTypeButtons.filter(x => {
        return x.type === this.searchType;
      });

      console.log("SEARCH BUTTON:", searchButton[0]);

      this.toggleSearch(searchButton[0]);
    } catch (err) {
      console.log("THERE WAS AN ERROR:", err);
    }*/
  }
};
</script>
<style scoped>
.influencer-img {
  width: 75px;
  margin: 10px;
  border-radius: 5px;
}
.searchSelected {
  color: white;
  background-color: orange !important;
}
.table-cell {
  width: 100%;
  padding: 10px;
}
.hashtag-item {
  white-space: nowrap;
}
</style>